import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable react/jsx-props-no-spreading, @typescript-eslint/ban-ts-comment, react/require-default-props */
import { forwardRef } from "react";
function withComponentOverride(DefaultComponent) {
    const Component = forwardRef(({ componentOverride: OverrideComponent, ...rest }, ref) => {
        if (OverrideComponent) {
            return _jsx(OverrideComponent, { ref: ref, defaultStyles: DefaultComponent?.componentStyle?.rules, ...rest });
        }
        // @ts-ignore
        return _jsx(DefaultComponent, { ref: ref, ...rest });
    });
    return Component;
}
export default withComponentOverride;
